/**
 * Created by Ivan on 21.01.2026
 */

const RiddlesMissionViewVertical = cc.Node.extend({
    ctor: function (controller, { closeWindowCallback }) {
        this._super();

        this.mission = controller.mission;
        this.options = controller.options || {};
        this.closeWindowCallback = closeWindowCallback;

        const styles = cleverapps.styles.RiddlesMissionViewVertical;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(cleverapps.resolution.getSceneSize());

        this.content = new cc.Node();
        this.content.setAnchorPoint(0.5, 0.5);
        this.content.setContentSize2(styles.size);
        this.addChild(this.content);
        this.content.setPosition(this.width / 2, this.height / 2);

        const bgRect = cleverapps.resolution.getBgRect();
        this.bg = new cc.Scale9Sprite(bundles.mission_window.frames.vertical_black_bg_png);
        this.bg.setContentSize2(bgRect);
        this.bg.setAnchorPoint(0, 0);
        this.addChild(this.bg, -1);
        this.bg.setPosition(bgRect.x, bgRect.y);

        const table = this.createTable();
        table.setAnchorPoint(0.5, 0.5);
        this.content.addChild(table);
        table.setAlignment(styles.table);

        const image = new cc.Sprite(bundles.mission_window.frames.vertical_image_png);
        this.content.addChild(image);
        image.setAlignment(styles.image);

        const titleBg = new cc.Sprite(bundles.mission_window.frames.vertical_title_png);
        this.content.addChild(titleBg);
        titleBg.setAlignment(styles.title);

        const title = cleverapps.UI.generateOnlyText(this.options.title || Messages.get(`Missions.${this.mission.getName()}.Title`), cleverapps.styles.FONTS.RIDDLES_MISSION_VERTICAL_TITLE_TEXT);
        titleBg.addChild(title);
        title.setAlignment(styles.title.text);
        title.fitTo(titleBg.width * 0.75);

        const helpButton = new cleverapps.UI.HelpButton({
            type: cleverapps.styles.UI.Button.Images.help_button_transparent,
            callback: () => {
                GuideWindow.createMissionRulesWindow(this.mission);
            }
        });
        titleBg.addChild(helpButton);
        helpButton.setAlignment(styles.helpButton);

        const closeButton = new CloseRoundButton({
            onClicked: this.closeWindowCallback,
            styles: styles.closeButton
        });
        this.addChild(closeButton, 2);

        if (this.mission.isRunning()) {
            const timer = new Timer(this.mission.getTimeLeft(), this.closeWindowCallback, {
                font: cleverapps.styles.FONTS.RIDDLES_MISSION_VERTICAL_TIMER_TEXT,
                timerBg: bundles.mission_window.frames.vertical_timer_bg_png,
                width: styles.timer.width,
                timerPosition: styles.timer.text,
                showHours: false
            });
            image.addChild(timer);
            timer.setAlignment(styles.timer);
        }
    },

    createTable: function () {
        const styles = cleverapps.styles.RiddlesMissionViewVertical.table;

        const mission = this.mission;
        const table = this.mission.runningCompetition.table;
        const tableRowIcon = MissionWindow.GetTableRowIcon(mission.type);
        const tableView = this.tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: !table.scrollDisabled,
            mouseScroll: !table.scrollDisabled,
            dock: { toEnd: false }
        });

        new TableHandler(table, tableView, {
            id: mission.type,
            height: styles.height,
            rowConstructor: RiddlesMissionVerticalRowView,
            rowOptions: {
                width: styles.width,
                height: styles.rowHeight,
                dataIcon: tableRowIcon.icon,
                dataIconAnimation: tableRowIcon.animation,
                dataIconAnimationEffect: tableRowIcon.effect,
                mission
            },
            styles: cleverapps.styles.RiddlesMissionViewVertical.tableStyles
        });

        return tableView;
    },

    onResize: function () {
        const styles = cleverapps.styles.RiddlesMissionViewVertical;

        this.setContentSize2(cleverapps.resolution.getSceneSize());

        this.content.setContentSize2(styles.size);
        this.content.setPosition(this.width / 2, this.height / 2);

        const bgRect = cleverapps.resolution.getBgRect();
        this.bg.setContentSize2(bgRect);
        this.bg.setPosition(bgRect.x, bgRect.y);
    },

    onShow: function () {
        this.mission.runningCompetition.table.showUp();
    },

    onClose: function () {
        this.mission.runningCompetition.updateShownPlace();
        this.mission.updateMissionIcon();
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RIDDLES_MISSION_VERTICAL_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    RIDDLES_MISSION_VERTICAL_TIMER_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.RiddlesMissionViewVertical = {
    size: {
        width: 660,
        height: 1300
    },

    tableStyles: {
        size: {
            width: 500,
            height: 732
        },

        margin: 7,
        padding: { x: 6, y: 2 },
        innerPadding: { x: 6, y: 12 },

        pinnedDy: 0,

        barPadding: {
            cornerPadding: 20,
            sidePadding: 5
        }
    },
    table: {
        margin: -2,
        x: { align: "center" },
        y: { align: "bottom", dy: -25 },
        width: 650,
        height: 820,
        rowHeight: 100
    },

    image: {
        x: { align: "center" },
        y: { align: "center", dy: 350 }
    },

    title: {
        x: { align: "center" },
        y: { align: "top" },
        text: {
            x: { align: "center" },
            y: { align: "center", dy: 15 }
        }
    },

    timer: {
        x: { align: "center" },
        y: { align: "bottom", dy: 17 },
        width: 220,
        text: {
            x: { align: "center", dx: 7 },
            y: { align: "center", dy: 3 }
        }
    },

    closeButton: {
        scale: [1, 1, 1],
        x: { align: "right", dx: 0 },
        y: { align: "top", dy: -20 }
    },

    margin: 30,

    helpButton: {
        x: { align: "left", dx: 35 },
        y: { align: "center", dy: 7 }
    }
};
